<template>
  <div v-if="!loading && myAddress !== undefined">
    <div class="row">
      <div class="col-md-12">
        <label class="font-weight-normal">
          {{$tc('direccion', 1)}}
          <span class="required">*</span>
        </label>
        <input
          type="text"
          class="woocommerce-Input woocommerce-Input--text input-text"
          v-model="myAddress.address"
          ref="address"
        />
      </div>
      <div class="col-md-6">
        <label class="font-weight-normal">
          {{$t('ciudad')}}
          <span class="required">*</span>
        </label>
        <input
          type="text"
          class="woocommerce-Input woocommerce-Input--text input-text"
          v-model="myAddress.city"
        />
      </div>
      <div class="col-md-6">
        <label class="font-weight-normal">
          {{$t('provincia')}}
          <span class="required">*</span>
        </label>
        <input
          type="text"
          class="woocommerce-Input woocommerce-Input--text input-text"
          v-model="myAddress.province"
        />
      </div>
      <div class="col-md-6">
        <label class="font-weight-normal">
          {{$t('codigo postal')}}
          <span class="required">*</span>
        </label>
        <input
          type="number"
          class="woocommerce-Input woocommerce-Input--text input-text"
          v-model="myAddress.postal_code"
        />
      </div>
      <div class="col-md-6">
        <label class="font-weight-normal">
          {{$t('pais')}}
          <span class="required">*</span>
        </label>
        <select
          class="woocommerce-Input woocommerce-Input--text input-text"
          v-model="myAddress.country_id"
        >
          <option
            v-for="pais in countries"
            v-bind:key="pais.id"
            v-bind:value="pais.id"
          >{{ pais.name | filterTranslateCountry( pais.id, pais.translations, $i18n.locale )}}</option>
        </select>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12">
        <button
          class="btn btn-sm btn-outline-primary mt-2 float-right pt-2 pb-2 btn-w ml-2"
          role="button"
          @click.prevent="saveAddress()"
        >
          {{ $t('guardar') }}
          <i class="fa fa-arrow-circle-down"></i>
        </button>
        <button
          class="btn btn-sm btn-outline-warning mt-2 float-right pt-2 pb-2 btn-w"
          role="button"
          @click.prevent="cancelEdit()"
        >
          {{ $t('cancelar') }}
          <i class="fa fa-arrow-circle-left"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "user-address-form",
  props: ["addressId", "countries", "finishEditAddress"],
  data() {
    return {
      dataLoaded : false,
      editingAddress : false,     
      myAddress : {} //Object.assign({}, this.address)
    };
  },
  methods: {
    ...mapActions("address", ["updateUserAddress", "getUserAddressById", "createUserAddress"]),
    
    saveAddress: function() {
        if (this.editingAddress === true) {
            this.updateUserAddress(this.myAddress);
            this.$emit("finishEditAddress");
        } else {
            this.createUserAddress(this.myAddress);
            this.$emit("finishEditAddress");
        }
    },
    cancelEdit() {
      this.$emit("finishEditAddress");
    },   

    setFocus: async function() {
      await this.$nextTick(function() {       
        this.$refs.address.focus();
      });
    }
  },
  computed: {
    ...mapState("address", ["loading"]),
    ...mapGetters("address", ["getCurrentEditAddress"]),
    
 /*    myAddress() {
      this.dataLoaded = true;
      return this.getCurrentEditAddress;
    } */
  },
  watch: {
    dataLoaded (newVal) {
      if(newVal) {
        this.$nextTick(() => {
          this.$refs.address.focus();
        })
      }
    },
    getCurrentEditAddress() {
        this.dataLoaded = true;
        this.myAddress = Object.assign({},this.getCurrentEditAddress);
      //return this.getCurrentEditAddress;

    }
  },
  created() {
    
  },
  mounted() {
      // comprobamos si es una actualizacion o no
      if (this.addressId > -1) {
          //estamos editando
          this.editingAddress = true;
          this.getUserAddressById(this.addressId);

      } else {

        console.log("Es una nueva direccion")

      }
    
  }
};
</script>

<style scoped>
.btn-w {
  min-width: 100px !important;
}
select:focus, input:focus {
  background-color:rgb(255, 252, 214);
  border-bottom:2px solid rgb(77, 77, 255);
 
}
</style>

